import React, { FC, useEffect } from 'react';
import styled from 'styled-components';

import { Book } from '~/api/book/bookApiTypes';
import { SCCatalogGrid } from '~/atomic/page/catalog/styled';
import { CSSSkeleton } from '~/atomic/page/index/styled';
import { BookCard } from '~/feature/book/BookCard/BookCard';
import { isLaptopSizeSelector, isMobileSizeSelector } from '~/feature/media/windowSize.selector';
import { useAppSelector } from '~/store';

export interface ContestSidebarBooksProps {
  onLoadBooks: () => void;
  books: Book[];
  isLoading: boolean;
}

export const ContestSidebarBooks: FC<ContestSidebarBooksProps> = ({
  books,
  isLoading,
  onLoadBooks,
}) => {
  const isMobileSize = useAppSelector(isMobileSizeSelector);
  const isLaptopSize = useAppSelector(isLaptopSizeSelector);

  useEffect(() => {
    if (!isMobileSize && !isLaptopSize) {
      onLoadBooks();
    }
  }, []);

  const isShowBooks = (books?.length ?? 0) > 0 && !isLoading;

  if (isMobileSize || isLaptopSize) {
    return null;
  }

  return (
    <SCContestSidebarBooks>
      {isLoading ? (
        <SCGrid>
          {Array(6)
            .fill('dummy')
            .map((dummy, index) => (
              <CSSSkeleton key={index} active />
            ))}
        </SCGrid>
      ) : null}
      {isShowBooks ? (
        <SCGrid>
          {books
            .filter((b, i) => i < 6)
            .map((book) => (
              <BookCard key={book.id} book={book} />
            ))}
        </SCGrid>
      ) : null}
    </SCContestSidebarBooks>
  );
};

const SCContestSidebarBooks = styled.div`
  width: 100%;
`;

const SCGrid = styled(SCCatalogGrid)`
  --items-count: 2;
`;
